import {FC, useEffect} from 'react'

import GoogleIcon from 'assets/svg/google_icon.svg'
import MicrosoftIcon from 'assets/svg/microsoft_icon.svg'
import {Footer} from 'components'
import LoginBg from 'assets/images/Login_bg_blue.jpg'
import {EndPoints} from 'services/api/HTTP/HTTP.types'
import {getBaseUrl} from 'services/api'
import Page from 'components/LLComp/Page'
import {translations} from 'definitions/externalization'
import {toast} from 'react-toastify'
import {Button} from 'design'

type Props = {
  location: {
    state: {
      invalidEmail: boolean
      errorType: string
    }
  }
}

const Login: FC<Props> = ({location}) => {
  const onLogin = (type: string) =>
    (window.location.href = `${getBaseUrl() + EndPoints.Login}=${type}${
      process.env.REACT_APP_ENV !== 'production' &&
      process.env.REACT_APP_ENV !== 'staging'
        ? '&redirectUrl=' + process.env.REACT_APP_REDIRECT_URL
        : ''
    }`)

  useEffect(() => {
    toast.dismiss()
  }, [])

  return (
    <Page>
      <div className="w-screen absolute">
        <img
          src={LoginBg}
          className="w-screen h-screen absolute object-cover z-10"
          alt="bg-img"
        />
        <div className="w-screen h-screen absolute justify-center items-center flex flex-col z-50 overflow-hidden">
          <section className="w-80 h-full">
            <div className="w-full h-full flex flex-col place-items-center justify-center items-center">
              <section className="w-full relative">
                <article
                  className="text-white text-4xl font-bold leading-9 abc-regular"
                  data-cy="dope-text"
                >
                  FLY
                  <br />
                  DOPE.<span className="cositimes font-normal">SECURITY</span>
                </article>
                <p
                  className="flex justify-start items-center text-sm mt-3 mb-9 karla-exl text-gray-10"
                  data-cy="login-text"
                >
                  Please log in to continue.
                </p>
                <Button
                  size="xlg"
                  className="mt-8"
                  onClick={() => onLogin('google')}
                  data-cy="login-button-google"
                >
                  <img
                    src={GoogleIcon}
                    className="w-4 h-4 mr-2 object-contain"
                    alt="gl-icon"
                  />
                  Sign in with Google
                </Button>

                <Button
                  size="xlg"
                  className="mt-3"
                  colorScheme="white"
                  onClick={() => onLogin('microsoft')}
                  data-cy="login-button-microsoft"
                >
                  <img
                    src={MicrosoftIcon}
                    className="w-4 h-4 mr-2 object-contain"
                    alt="ms-icon"
                  />
                  Sign in with Microsoft
                </Button>
                <p
                  className="text-sm mt-2 text-left karla-exl text-gray-10"
                  data-cy="corporate-email-text"
                >
                  *Corporate email required
                </p>
              </section>
              <div>
                <p
                  data-cy="non-enterprise-email-error"
                  className={`py-5 text-red-400 abc-regular text-xs md:text-sm mb-10 ${
                    location?.state?.invalidEmail &&
                    location?.state?.errorType === 'invalid'
                      ? 'block'
                      : 'hidden'
                  }`}
                >
                  {translations.CORPORATE_DOMAIN_REQUIRED}
                </p>
                <p
                  data-cy="non-verified-email-error"
                  className={`py-5 text-red-400 abc-regular text-xs md:text-sm mb-10 ${
                    location?.state?.invalidEmail &&
                    location?.state?.errorType === 'unverified'
                      ? 'block'
                      : 'hidden'
                  }`}
                >
                  {translations.USER_NOT_VERIFIED}
                </p>
                <p
                  data-cy="non-verified-email-error"
                  className={`py-5 text-red-400 abc-regular text-xs md:text-sm mb-10 ${
                    location?.state?.invalidEmail &&
                    location?.state?.errorType === 'needHelp'
                      ? 'block'
                      : 'hidden'
                  }`}
                >
                  {translations.LOGIN_NEED_HELP}
                </p>
              </div>
              <Footer />
            </div>
          </section>
        </div>
      </div>
    </Page>
  )
}

export default Login
